import type {FC} from 'react';
import type {Dispatch, SetStateAction} from 'react';
import type {FormType} from '@wellstone-solutions/common';
import {Theme} from '@wellstone-solutions/common';
import type {Event} from 'api/v2';
import {
  Button,
  Icon,
  IconNames,
  Stack,
  Typography,
} from '@wellstone-solutions/web';
import {EventForm} from './EventForm';
import {
  eventFormHelperText1,
  eventFormHelperText2,
  MAX_NUM_GROUP_EVENTS,
} from 'modules/group/constants';

type EventsUI = {
  isVisible: boolean;
  isOpen: boolean;
};

type PropsType = {
  groupId: string;
  forms: Array<FormType<Event>>;
  eventsUI: Array<EventsUI>;
  setEventsUI: Dispatch<SetStateAction<Array<EventsUI>>>;
};

export const EventFormList: FC<PropsType> = ({
  groupId,
  forms,
  eventsUI,
  setEventsUI,
}) => {
  const toggleAddNewEvent = () => {
    const targetIndex = eventsUI.findIndex((event) => !event.isVisible);

    if (targetIndex <= MAX_NUM_GROUP_EVENTS - 1) {
      setEventsUI((prev) => {
        const newEventUI = [...prev];
        newEventUI[targetIndex].isVisible = true;
        newEventUI[targetIndex].isOpen = false;

        return newEventUI;
      });
    }
  };

  const disableCreateButton =
    eventsUI.filter((event) => event.isVisible).length === MAX_NUM_GROUP_EVENTS;

  return (
    <Stack direction="column">
      {forms
        .filter((_, i) => eventsUI[i].isVisible)
        .map((form, index) => (
          <EventForm
            groupId={groupId}
            form={form}
            key={`group-event-${index}`}
            index={index}
            eventsUI={eventsUI}
            helperText={
              index === 0 ? eventFormHelperText1 : eventFormHelperText2
            }
          />
        ))}
      <Button
        variant="outlined"
        disabled={disableCreateButton}
        onClick={toggleAddNewEvent}
        sx={{mt: 4, width: 'fit-content'}}>
        <Icon
          name={IconNames.Plus}
          color={
            !disableCreateButton
              ? Theme.colorPalette.primary
              : Theme.colorPalette.mediumDark
          }
        />
        <Typography sx={{ml: 1, pr: 2, fontWeight: 'bold'}}>
          Create another group meeting
        </Typography>
      </Button>
    </Stack>
  );
};
